<template>
  <div
    v-show="!hidden"
    class="my-0 flex w-full flex-col items-start"
  >
    <label
      v-if="label"
      class="w-full text-left text-xs font-bold uppercase"
      :class="[
        isValid & !empty_field ? 'text-gray-dark' : 'text-red-500',
        { 'text-gray-over-dark': empty_field },
      ]"
      :for="label"
    >
      {{ hideLabel ? '' : label }}
      <div
        class="relative z-10 w-full"
        :class="{ 'mt-2': !hideLabel }"
      >
        <!-- eslint-disable -->
        <input
          :readonly="isSlim"
          :disabled="isSlim ? 'disabled' : ''"
          :id="label"
          class="peer w-full rounded-lg border border-transparent"
          :class="{
            'bg-off-white': isValid,
            'bg-red-100 text-red-500': !isValid,
            'monospace text-base tracking-wide text-dark-gray': monospace,
            'pl-6': isMonetary,
            'no-outline px-3 py-3 text-xs': isSlim,
            'px-4 py-4 text-sm': !isSlim,
          }"
          v-model="inputVal"
          :type="name.includes('email') ? 'email' : type"
          :placeholder="placeholder"
          :name="name"
        />
        <span
          v-if="isMonetary"
          class="text-dark monospace absolute left-0 top-0 flex h-full w-8 items-center justify-center text-base font-medium"
        >
          $
        </span>
        <!-- eslint-enable -->
        <span
          v-if="inputType == 'search'"
          class="text-placeholder-gray peer-focus:text-yellow-500"
        >
          <svg
            class="absolute right-4 top-5 mt-1 h-6 w-6 group-focus:text-yellow-500"
            viewBox="0 0 17 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.7893 12.7305L16.2692 17.2104"
              stroke="currentColor"
              stroke-width="2"
            />
            <circle
              cx="7.9493"
              cy="8.25118"
              r="6.67989"
              stroke="currentColor"
              stroke-width="2"
            />
          </svg>
        </span>
        <span
          v-if="showConfirmButton == true"
          class="text-placeholder-gray"
        >
          <button
            type="button"
            :disabled="!confirmBtnActivated"
            class="absolute bottom-0 right-0 top-0 z-10 flex h-full w-32 items-center justify-center rounded-r-md text-xs font-bold uppercase"
            :class="{
              'cursor-not-allowed gap-1 border-l border-placeholder-gray bg-placeholder-gray text-body-color':
                !confirmBtnActivated,
              'pulse-btn pulse cursor-pointer gap-2 border-l border-yellow-500 bg-yellow-500 text-white':
                confirmBtnActivated,
            }"
            @click="handleConfirm"
          >
            <svg
              v-if="confirmBtnText == 'Confirmed'"
              class="h-4 w-4"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.30466 12.2119C9.35139 12.2119 11.8212 9.74201 11.8212 6.69529C11.8212 5.8144 11.6148 4.98173 11.2476 4.24303L6.49714 8.99348L5.93988 9.55074L5.38262 8.99348L2.95534 6.56621L4.06986 5.45169L5.93988 7.32171L10.3341 2.92748C9.32739 1.8513 7.89458 1.17871 6.30466 1.17871C3.25794 1.17871 0.788086 3.64857 0.788086 6.69529C0.788086 9.74201 3.25794 12.2119 6.30466 12.2119Z"
                fill="currentColor"
              />
            </svg>
            {{ confirmBtnText }}
            <svg
              v-if="confirmBtnText == 'Confirm'"
              class="h-3 w-3 rotate-180 transform"
              :class="{
                'text-white': confirmBtnActivated,
                'text-body-color': !confirmBtnActivated,
              }"
              viewBox="0 0 19 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 2L3 10L11 18"
                stroke="currentColor"
                stroke-width="3"
              />
              <path
                d="M4 10L19 10"
                stroke="currentColor"
                stroke-width="3"
              />
            </svg>
          </button>
        </span>
        <span
          v-if="showConfirmButton == false && inputType == 'date'"
          class="text-placeholder-gray"
        >
          <button
            type="button"
            class="datepicker-btn absolute bottom-0 right-0 top-0 z-10 flex h-full w-10 cursor-pointer items-center justify-center rounded-r-lg border-b-2 border-r-2 border-t-2 text-xs font-bold uppercase"
            :class="{
              'bg-yellow-500 text-white hover:border-yellow-500 hover:bg-yellow-500 focus:border-yellow-500':
                inputVal?.length,
              'border-light-gray bg-light-gray text-gray-over-dark hover:border-placeholder-gray hover:bg-placeholder-gray hover:text-body-color':
                !inputVal?.length,
              'no-outline': isSlim,
            }"
            @click="toggleDatePicker"
          >
            <svg
              class="datepicker-calendar-icon h-5 w-5"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="3"
                y="4"
                width="18"
                height="16"
                rx="2"
                stroke="currentColor"
                stroke-width="2"
              />
              <path
                d="M2 8H22"
                stroke="currentColor"
                stroke-width="2"
              />
              <rect
                x="16"
                y="2"
                width="2"
                height="4"
                fill="currentColor"
              />
              <rect
                x="6"
                y="2"
                width="2"
                height="4"
                fill="currentColor"
              />
            </svg>
          </button>
        </span>

        <span v-if="!isValid">
          <!-- <img src="@/assets/red-checkmark.svg" alt="" class="h-6 w-6 absolute right-4 top-5 mt-1"> -->
        </span>
      </div>
    </label>
    <span
      v-if="!isValid && !name.includes('account_number')"
      class="mt-2 text-2xs text-red-500"
    >
      {{ errorMessage }}
    </span>
    <span
      v-if="!isValid && name.includes('account_number')"
      class="text-xm text-red-500"
      :class="name.includes('verify_account_number') ? 'mt-2' : ''"
    >
      {{ errorMessage }}
    </span>
  </div>
</template>
<script>
// import { isEmail } from "@/common/validators";
import { ref, toRef, watch, computed } from 'vue';
import dayjs from 'dayjs';

export default {
  name: 'FormFieldDate',
  props: {
    label: String,
    type: {
      default: 'text',
      type: String,
    },
    // value: String,
    placeholder: String,
    errorMessage: String,
    name: String,
    onInput: Function,
    isValid: {
      default: true,
    },
    pattern: String,
    empty_field: {
      type: Boolean,
      default: false,
    },
    inputType: {
      type: String,
      default: '',
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    monospace: {
      type: Boolean,
      default: false,
    },
    showConfirmButton: {
      type: Boolean,
      default: false,
    },
    toggleOffButton: {
      type: Boolean,
      default: false,
    },
    modelValue: String,
    monetary: {
      type: Boolean,
      default: false,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    isSlim: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    // let valueProp = props.value;
    // const valuePropRef = toRef(props, 'value');
    const modelPropRef = toRef(props, 'modelValue');
    const isMonetary = toRef(props, 'monetary');
    const namePropRef = toRef(props, 'name');
    const modelProp = ref('');
    modelProp.value = modelPropRef.value;
    // watch(modelPropRef, (newVal) => {
    //   if (newVal) {
    //     modelProp.value = newVal;
    //   }
    // });
    if (props.inputType == 'date') {
      modelProp.value = dayjs(modelProp.value, 'YYYY-MM-DD').format('MM/DD/YY');
    }
    // const inputVal = computed({
    //   get: () => modelProp.value,
    //   set: (value) => context.emit('update:modelValue', value)
    // });
    // const inputVal = computed({
    //   get: () => props.modelValue,
    //   set: (value) => context.emit('update:modelValue', { "name": props.name, "value": value })
    // });
    const inputVal = computed({
      get: () => props.modelValue,
      set: (value) =>
        context.emit('update:modelValue', {
          name: namePropRef.value,
          value: value,
        }),
    });
    // inputVal.value = valuePropRef.value;
    let confirmBtnText = ref('Confirm');
    const confirmBtnActivated = ref(false);
    // if (valuePropRef.value?.length > 0) {
    //   confirmBtnActivated.value = true;
    // }
    const validatedInput = (e) => {
      if (e.target.value) {
        confirmBtnActivated.value = true;
        confirmBtnText.value = 'Confirm';
        context.emit('valueConfirmed', null);
        // inputVal.value = e.target.value;
        // modelProp.value = e.target.value;
      } else {
        confirmBtnActivated.value = false;
      }
      // if ((inputVal.value != e.target.value) && (e.target.value))  {
      //   confirmBtnActivated.value = true;
      //   confirmBtnText.value = "Confirm";
      // }
      // inputVal.value = e.target.value;
      // if ( inputVal.value.length == 0 ) {
      //   confirmBtnActivated.value = false;
      //   confirmBtnText.value = "Confirm";
      //   context.emit("valueConfirmed", null);
      // }
      // if (e.target.name.includes("policy_number")) {
      //   console.log('contains policy_number');
      //   console.dir(e);
      //   return props.onInput(props.name, inputVal.value);
      // }
    };
    const handleConfirm = () => {
      if (confirmBtnActivated.value == true) {
        confirmBtnText.value = 'Confirmed';
        confirmBtnActivated.value = false;
        if (inputVal.value.length == 0) {
          // console.log('inputVal.value is empty');
          // console.log('valueProp = '+valueProp);
          // inputVal.value = valuePropRef.value;
        }
        context.emit('valueConfirmed', inputVal.value);
      }
    };
    function displayDate(initialDate) {
      if (initialDate == null) {
        return initialDate;
      } else {
        return dayjs(initialDate, 'YYYY-MM-DD').format('MM/DD/YY');
      }
    }
    const showDatePicker = ref(false);
    const toggleDatePicker = () => {
      showDatePicker.value = !showDatePicker.value;
      context.emit('toggleDatePicker', props.name);
    };

    // const newWatch = watch(valuePropRef, (newVal) => {
    //   if (newVal) {
    //     confirmBtnActivated.value = true;
    //     confirmBtnText.value = "Confirm";
    //     inputVal.value = newVal;
    //     context.emit("valueConfirmed", null);
    //   } else {
    //     confirmBtnActivated.value = false;
    //   }
    // });

    // const newWatchValue = watch(modelProp, (newVal) => {
    //   if (newVal) {
    //     inputVal.value = newVal;
    //   }
    // });

    const togglePropRef = toRef(props, 'toggleOffButton');
    const watchToggleButton = watch(togglePropRef, (newVal) => {
      if (newVal == true) {
        showDatePicker.value = false;
      }
    });

    return {
      validatedInput,
      confirmBtnActivated,
      confirmBtnText,
      handleConfirm,
      inputVal,
      // valuePropRef,
      // newWatch,
      toggleDatePicker,
      showDatePicker,
      watchToggleButton,
      displayDate,
      modelPropRef,
      modelProp,
      isMonetary,
      ...props.field,
    };
  },
};
</script>

<style scoped>
input.peer:not(:focus) + span > button.datepicker-btn {
  @apply border-transparent;
}
/* input.peer:focus + span > button.datepicker-btn {
  @apply border-body-color;
} */
</style>
